import { useMobileView as useBgMobileView } from '@betgames/bg-tools';
import { MAX_DESKTOP_VIEW_WIDTH } from 'constants/constants';

export const useMobileView = useBgMobileView.bind(null, MAX_DESKTOP_VIEW_WIDTH);
